import * as types from '../constants/ActionTypes'
//import config from '../../config/app.js';
import omit from 'lodash'

export default function videos(state = {}, action) {
	switch (action.type) {

		case types.SET_VIDEOS:
			return action.payload.reduce((obj, area) => {
				obj[area._id] = area;
				return obj
			}, {});

		case types.UPDATE_VIDEO:
		case types.INSERT_VIDEO:
			return {...state, [action.payload._id]: action.payload};

		case types.DELETE_VIDEO:
			return omit(state, action.payload)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/videos.js